import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PowerProfile, PowerProfileDTO } from '../models/power-profile.interface';
import { PowerProfileResource } from '../resources/power-profile.resource';

@Injectable({
  providedIn: 'root'
})
export class PowerProfileService {
  constructor(private powerProfileResource: PowerProfileResource) {}

  getProfiles(buildingId: number): Observable<PowerProfile[]> {
    return this.powerProfileResource.getProfiles(buildingId);
  }

  getNodeAssignments(buildingId: number): Observable<Record<number, number[]>> {
    return this.powerProfileResource.getNodeAssignments(buildingId);
  }

  createProfile(dto: PowerProfileDTO, buildingId: number): Observable<PowerProfile> {
    return this.powerProfileResource.createProfile(dto, buildingId);
  }

  updateProfile(profile: PowerProfile, buildingId: number): Observable<PowerProfile> {
    return this.powerProfileResource.updateProfile(profile, buildingId);
  }

  assignNodes(profileId: number, nodeIds: number[]): Observable<void> {
    return this.powerProfileResource.assignNodes(profileId, nodeIds);
  }
}
